import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { Box, LinearProgress, Tab, Tabs, Typography } from '@mui/material';
import { tabsClasses } from '@mui/material/Tabs';

import useNotification from '../../../../core/hooks/use_notification';
import { ROUTE_FOOD_PARTNERS } from '../../../../core/constants';
import FoodPartnerForm from './food_partner/food_partner_form';
import { getFoodPartnerAction, getFoodPartnerState } from '../../../../features/food_partner/get_food_partner';
import { getFoodPartnerNotificationData } from '../../../../core/utils/notification_utils';
import DocumentsForm from './document/documents_form';
import ContactPersonsForm from './contact_person/contact_persons_form';
import PageHeader from '../../../common/page_header';

const FoodPartnerPage = () => {
    const { showErrorMessage } = useNotification();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { foodPartnerId } = useParams();

    const [tab, setTab] = useState(0);

    const getFoodPartner = useSelector(getFoodPartnerState);

    useEffect(() => {
        foodPartnerId && dispatch(getFoodPartnerAction(foodPartnerId))
            .then(response => showErrorMessage((getFoodPartnerNotificationData(response))));
    }, [foodPartnerId, dispatch, showErrorMessage]);

    const renderView = () => {
        if (getFoodPartner?.loading) {
            return (
                <Box mt={ 6 }>
                    <LinearProgress/>
                </Box>
            );
        }

        switch (tab) {
            case 1:
                return <ContactPersonsForm foodPartnerId={ foodPartnerId }/>;
            case 2:
                return <DocumentsForm foodPartnerId={ foodPartnerId }/>;
            default:
                return <FoodPartnerForm foodPartnerId={ foodPartnerId }/>;
        }
    }

    return (
        <Box sx={ {
            display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3
        } }>
            <PageHeader
                title={ foodPartnerId ? getFoodPartner?.data?.name || "Edycja dostawcy" : "Nowy dostawca" }
                showBack={ true }
                onBack={ () => navigate(ROUTE_FOOD_PARTNERS) }
                titleAdornment={
                    foodPartnerId && getFoodPartner?.data && (
                        <Typography variant="h6" color="textSecondary">
                            ID: { foodPartnerId }
                        </Typography>
                    )
                }
            />

            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => setTab(value) }
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Informacje ogólne"/>
                    <Tab label="Osoby kontaktowe" disabled={ !foodPartnerId }/>
                    <Tab label="Dokumenty" disabled={ !foodPartnerId }/>
                </Tabs>
            </Box>

            <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                { renderView() }
            </Box>
        </Box>
    );
}

export default FoodPartnerPage;